import { createSelector } from 'reselect';

import { RootState } from 'store';

const selectStrapiState = (state: RootState) => state.strapi;

export const selectClosedTopBanners = createSelector(
  selectStrapiState,
  state => state.closedTopBanners,
);
